var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exit-button"},[_c('v-btn',{attrs:{"app":"","dark":"","text":""},on:{"click":_vm.onLogout}},[_c('v-icon',{staticClass:"hover-logout",attrs:{"size":"25"}},[_vm._v("mdi-power")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }